import React from "react";
import "./services.css";

export default function Services() {
  return <div className="services-section">Services</div>;
}
